import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpWanaka } from '../utils/http.wanaka';

const APPLICATION_TYPE_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

@Injectable({ providedIn: 'root' })
export class ExportsService {
  private exportsUrl = '/exports';
  constructor(private http: HttpWanaka) {}

  downloadCommands(
    campaignId: number,
    filter?: { has_t2?: boolean; completed?: boolean },
    specy?: 'ble' | 'colza' | 'orge',
  ): Observable<Blob> {
    let url = `${this.exportsUrl}/commands?campaignId=${campaignId}`;
    if (specy) url += `&specy=${specy}`;
    if (filter) {
      if (filter.has_t2 != null) {
        url += `&has_t2=${filter.has_t2}`;
      }
      if (filter.completed != null) {
        url += `&completed=${filter.completed}`;
      }
    }
    return this.http.blobQuery(url, APPLICATION_TYPE_XLSX);
  }

  downloadResults(campaignId: number): Observable<Blob> {
    const url = `${this.exportsUrl}/results?campaignId=${campaignId}`;
    return this.http.blobQuery(url, APPLICATION_TYPE_XLSX);
  }

  downloadIncompleteCommands(cropPath: 'ble' | 'colza' | 'orge', campaignId: number): Observable<Blob> {
    const url = `${this.exportsUrl}/commands/incomplete?specy=${cropPath}&campaignId=${campaignId}`;
    return this.http.blobQuery(url, APPLICATION_TYPE_XLSX);
  }

  downloadLateCommands(cropPath: 'ble' | 'colza' | 'orge', campaignId: number): Observable<Blob> {
    const url = `${this.exportsUrl}/commands/late?specy=${cropPath}&campaignId=${campaignId}`;
    return this.http.blobQuery(url, APPLICATION_TYPE_XLSX);
  }
}
